// Dependencies
import React from "react";
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
// Components
import { generateMarkers } from "../pieChart/PieChartLegend";

// Material-UI
import { Box, Typography } from "@mui/material";
import { useGetTheme } from "../../../../hooks";

import { QUESTION_INTL } from "../../../../consts.js";

function PercentageGraphLegend({
  legendData,
  transformLegendText,
  selectedAssignment,
  selectedAssignmentData
}) {
  // Hooks
  const navigate = useNavigate();
  const theme = useGetTheme();
  const intl = useIntl();

  const renderLegendItem = (key, value, percentage) => {
    // eslint-disable-next-line no-unused-vars
    const [part1, part2] = key.split(/_(.+)/);
    let markerKey;
    let legendText;
    markerKey = `${key}`;
    legendText = transformLegendText(markerKey, percentage);
    if (!legendText) {
      return null;
    }

    return (
      <Box
        key={key}
        sx={{
          display: "flex",
          alignItems: "center",
          marginInlineStart: "8px",
          marginInlineEnd: "8px",
          marginBlockEnd: "16px"
        }}>
        {legendText ? generateMarkers(markerKey, value, theme) : null}
        <Typography
          variant="caption"
          sx={{ marginInlineStart: "8px", color: theme.palette.text.primary }}>
          {legendText}
        </Typography>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexFlow: "column",
        width: "100%",
        height: "30%",
        marginInlineStart: "24px",
        marginBlockStart: "24px"
      }}>
      <Box
        sx={{
          paddingInlineStart: "8px",
          width: "fit-content"
        }}>
        {selectedAssignment && (
          <Typography
            variant="subtitle2"
            sx={{ cursor: "pointer" }}
            onClick={() => {
              navigate(`/reports/stats?task_id=${selectedAssignment.id}`);
            }}>
            <Box component="span" sx={{ marginRight: "64px" }}>
              {selectedAssignment?.name}
            </Box>
            {selectedAssignment?.questions &&
              Array.isArray(selectedAssignment.questions) && (
                <Box component="span">
                  {intl.formatMessage({
                    id: `task.type.${selectedAssignment?.task_type}`,
                    defaultMessage: "Standard"
                  })}{" "}
                  | {selectedAssignment.questions.length} questions |{" "}
                  {[...new Set(selectedAssignment.questions)]
                    .map((t) =>
                      intl.formatMessage({
                        id: QUESTION_INTL[t].translationId,
                        defaultMessage: QUESTION_INTL[t]?.defaultMessage
                      })
                    )
                    .join(",")}
                  {("| " + selectedAssignmentData?.submissionsTotal || 0) +
                    " Submissions | " +
                    (selectedAssignmentData?.total || 0) +
                    " Answers"}
                </Box>
              )}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexFlow: "row",
          marginBlockStart: "16px"
        }}>
        <Box
          sx={{
            width: "auto",
            display: "flex",
            flexFlow: "row wrap",
            paddingInlineEnd: "40px",
            paddingInlineStart: 0
          }}>
          {legendData?.map((item) =>
            renderLegendItem(item.cat, item.val, item.percentage)
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default PercentageGraphLegend;
